import * as React from "react";
import { Stack, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import { useQueryClient } from "@tanstack/react-query";

import { createCheckpoint } from "../../../schemas/addCheckpoint";
import {RFHTextField as RHFTextField, RFHdatePicker, RHFCheckbox} from '../../RFH'

import { addCheckpoint } from "../../../services/apiEpic";
import { useCustomSearchParams } from "../../../hooks/useCustomSearchParams";
import { useResponsive } from "../../../hooks/useResponsive";
import useMutate from "../../../hooks/useMutate";
import "./../milestone.scss";
import FormDialog from "../../Dialog/FormDialog";

export default function AddCheckpoint({ open, handleClose }) {
  const queryClient = useQueryClient();
  const methods = useForm({
    resolver: yupResolver(createCheckpoint),
  });
  const [milestone, setMilestone] = useCustomSearchParams("milestone");
  const isMobile = useResponsive("down", "md");
  const { mutate, isPending } = useMutate(addCheckpoint, [], () => {
    queryClient.invalidateQueries({
      queryKey: ["checkpoints", milestone],
    });
    queryClient.invalidateQueries({ queryKey: ["boards"] });
    methods.reset();
    handleClose();
  });

  const onSubmit = (formData) => {
    mutate({
      epic_id: milestone,
      data: {
        ...formData,
        datetime: moment(formData.datetime).format("YYYY-MM-DD"),
      },
    });
  };
  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <FormDialog
            open={open}
            handleClose={handleClose}
            handleSubmit={methods.handleSubmit(onSubmit)}
            title={"Add Checkpoint"}
            buttonTxt={"Add"}
            width={613}
            isLoading={isPending}
            className="add-checkpoint-dialog"
            cancelBtn={true}
            fullWidth={true}>
            <Typography className="milestone-lable">Checkpoint Name</Typography>
            <RHFTextField name={"checkpoint_name"} />

            <Typography className="milestone-lable" mt={isMobile ? 1 : 2}>
              Target Date
            </Typography>
            <RFHdatePicker name={"datetime"} />

            <Stack alignItems="center" direction="row" mt={isMobile ? 1 : 2}>
              <Typography className="milestone-lable" mr={2}>
                Is Done
              </Typography>
              <RHFCheckbox name={"is_done"} />
            </Stack>
          </FormDialog>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}
